import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  multiPackageDeleteSetButton: {
    description: 'Button to delete multi-package set',
    defaultMessage: 'Delete Multi-Package Set',
    id: 'yGWyK5',
  },
  deletePackageSetModalTitle: {
    description: 'Title for delete package set modal',
    defaultMessage: 'Delete Multi-Package Set',
    id: '3DMyAM',
  },
  deletePackageSetModalText: {
    description: 'Text to explain the delete package set modal',
    defaultMessage: 'Are you sure you want to delete this multi-package set permanently?',
    id: '+4lAps',
  },
});
